import Image from 'next/image';
import { Box, Flex } from 'rebass/styled-components';

import Text from '@/components/Text';

const NoAppointment = () => (
  <Flex justifyContent="center" py={10} px={10}>
    <Box textAlign="center" mt={1} mb={2}>
      <Image src="/assets/relax.webp" width="216px" height="220px" />
      <Text mb={['10px', '10px', '10px']} variant="capsTitle">
        Zeit zum Entspannen
      </Text>
      <Text variant="small">Aktuell gibt es keine Ereignisse.</Text>
    </Box>
  </Flex>
);

export default NoAppointment;
